import React from 'react';
import { SERVICEDESK_QUEUE_PAGE_MODULE } from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import { ForgeAnalyticsWrapper } from '../../common/ui/index.tsx';
import type {
	AnalyticsWrapperPropsTrigger,
	AnalyticsWrapperPropsView,
} from '../../common/ui/types.tsx';
import { MODULE_TYPE_TRIGGER } from '../../constants.tsx';

export const ViewAnalyticsWrapper = (props: AnalyticsWrapperPropsView) => (
	<ForgeAnalyticsWrapper
		module={SERVICEDESK_QUEUE_PAGE_MODULE}
		shouldFireInitializedEvent
		{...props}
	/>
);

export const TriggerAnalyticsWrapper = (props: AnalyticsWrapperPropsTrigger) => (
	<ForgeAnalyticsWrapper
		module={SERVICEDESK_QUEUE_PAGE_MODULE}
		moduleType={MODULE_TYPE_TRIGGER}
		{...props}
	/>
);
